import type { CommanderDefinition } from './types';

export const COMMANDERS: CommanderDefinition[] = [
  {
    id: 'vael',
    name: 'Marshal Vael',
    title: 'The Lane Warden',
    color: '#ff8a3d',
    passiveName: 'Hardened Muster',
    passiveDescription: 'Your minions have +15% health.',
    activeName: 'Rally',
    activeDescription:
      'Every tower switches to the lane under the heaviest enemy pressure and instantly musters one minion there.',
    cooldown: 40,
  },
  {
    id: 'oda',
    name: 'Tinker Oda',
    title: 'The Recycler',
    color: '#4ad9c8',
    passiveName: 'Cheap Labor',
    passiveDescription: 'Summon cost climbs 30% slower.',
    activeName: 'Wildcard',
    activeDescription:
      'Your next summon is free and guaranteed to match a family already on your board, setting up a merge.',
    cooldown: 50,
  },
  {
    id: 'brakk',
    name: 'Warlord Brakk',
    title: 'The Overcharger',
    color: '#ff4b6e',
    passiveName: 'Quick Hands',
    passiveDescription: 'Your towers fire 10% faster and your minions deal +12% damage.',
    activeName: 'Overcharge',
    activeDescription:
      'For 8 seconds your towers fire twice as fast and minions mustered move 50% faster and hit 50% harder.',
    cooldown: 45,
  },
];

export const COMMANDER_BY_ID: Record<string, CommanderDefinition> = Object.fromEntries(
  COMMANDERS.map((c) => [c.id, c]),
);
